import IstModal from "./IstModal.vue";
import IstLayoutCard from "./IstLayoutCard.vue";
import IstFormSelect from "./IstFormSelect.vue";
import IstFormSearch from "./IstFormSearch.vue";
import IstFormTime from "./IstFormTime.vue";
import IstNumberInput from "./IstNumberInput.vue";
import IstToolbarDate from "./IstToolbarDate.vue";
import IstToolbarWeek from "./IstToolbarWeek.vue";
import IstFormInput from "./IstFormInput.vue";
import IstDatePicker from "./IstDatePicker.vue";
import IstAvatar from "./IstAvatar.vue";
import IstChipSelect from "./IstChipSelect.vue";
import IstMultipleSelect from "./IstMultipleSelect.vue";

export default {
  install(Vue) {
    Vue.component("ISTModal", IstModal);
    Vue.component("ISTLayoutCard", IstLayoutCard);
    Vue.component("ISTFormSelect", IstFormSelect);
    Vue.component("ISTFormSearch", IstFormSearch);
    Vue.component("ISTFormTime", IstFormTime);
    Vue.component("ISTNumberInput", IstNumberInput);
    Vue.component("ISTToolbarDate", IstToolbarDate);
    Vue.component("ISTToolbarWeek", IstToolbarWeek);
    Vue.component("ISTFormInput", IstFormInput);
    Vue.component("ISTDatePicker", IstDatePicker);
    Vue.component("ISTAvatar", IstAvatar);
    Vue.component("ISTChipSelect", IstChipSelect);
    Vue.component("ISTMultipleSelect", IstMultipleSelect);
  }
};
